import moment from 'moment'

import { getI18n } from '@/plugins/i18n'

import { useLookup } from '@/composables/data-grid'
import * as dataGridColumn from '@/composables/data-grid-column'

import { usePortalStore } from '@/stores/portal.store'

export const useColumns = (currentSaleDocumentPage) => {
  const i18n = getI18n()
  const portalStore = usePortalStore()

  return [
    { caption: '', width: '6.5rem', cellTemplate: 'electronicInvoiceButtonsTemplate' },
    dataGridColumn.useDateColumn({ dataField: 'document_date', width: '6rem' }),
    dataGridColumn.useSeriesColumn({ dataField: 'document_series', width: '5rem' }),
    dataGridColumn.useNumberMnemonicColumn({ dataField: 'document_number_mnemonic', width: '5rem' }),
    dataGridColumn.useCustomerColumn({
      caption: i18n.t('common.customerData'),
      width: '7rem',
      dataField: 'document_customer_id',
      validationRules: []
    }),
    dataGridColumn.useSaleDocumentTypeColumn({ dataField: 'document_type', currentSaleDocumentPage: { value: currentSaleDocumentPage }, width: '7rem' }),
    dataGridColumn.useReferenceDocumentColumn({
      dataField: 'sale_document_id',
      caption: i18n.t('common.saleDocument'),
      width: '10rem',
      editCellTemplate: 'saleDocumentRef',
      cellTemplate: 'saleDocumentRef',
    }),
    dataGridColumn.useSaleReasonRefColumn({ width: '7rem' }),
    dataGridColumn.useTotalVatColumn({ width: '5rem' }),
    {
      caption: i18n.t('common.family'),
      width: '9rem',
      dataField: 'progress_status_family_code',
      calculateCellValue: (rowData) => {
        const status = Object.values(portalStore.electronicInvoiceProgressStatusesEnum).find(x => x.id === rowData.progress_status_code)
        return status?.family ?? null
      },
      cellTemplate: 'electronicInvoiceFamilyCellTemplate',
    },
    {
      caption: i18n.t('common.progressStatus'),
      width: '9rem',
      dataField: 'progress_status_code',
      lookup: useLookup({ store: portalStore.getLocalizedElectronicInvoiceProgressStatuses() }),
    },
    {
      dataField: 'updated_at',
      caption: i18n.t('common.updatedAt'),
      dataType: 'datetime',
      width: '9rem',
      calculateDisplayValue: (rowData) => moment.utc(rowData.updated_at.toString()).local().toDate(),
      calculateFilterExpression: (filterValue, selectedFilterOperation, target) => {
        if (!filterValue) return null
        const utcValue = moment(filterValue).utc().toISOString()
        return ['updated_at', selectedFilterOperation || '=', utcValue]
      }
    },
    {
      dataField: 'message', caption: i18n.t('common.message'),
      calculateCellValue: (data) => data?.message ? i18n.t(data?.message) : ''
    },
    { caption: i18n.t('common.error'), width: '5rem', cellTemplate: 'electronicInvoiceErrorTemplate', visible: false },
  ]
}
